:host{width:100%;display:flex;background-color:#fff;justify-content:flex-end;border-right:2px solid rgba(35,36,38,.12)}
/*# sourceMappingURL=gen-ai-toolbar.component.css.map */
